<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']">
          <i class="fa fa-truck"></i>
          Lieferscheine
        </a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', deliveryNote.id]">
          {{ deliveryNote.number }}
        </a>
      </li>
      <li>
        <a>Lieferung quittieren</a>
      </li>
    </ul>
  </div>
</div>

<div class="page-content page-frame">
  @if (deliveryNote) {
    <form class="page-sheet flex flex-col gap-4 h-full" [formGroup]="deliveryNoteReceipt" (submit)="saveReceipt()">
      <div class="flex-none bm-alert bm-alert-error bm-alert-dash">
        <div>
          <h4 class="font-bold">Hinweis</h4>
          <div>
            Sie bestätigen hiermit den Empfang der Lieferung und müssen festlegen, was mit den gelieferten Artikeln
            passieren soll.
          </div>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <fieldset class="bm-fieldset flex-1">
          <legend class="bm-fieldset-legend">Ort</legend>
          <ng-select
            class="w-full"
            [items]="locations"
            formControlName="location"
            placeholder="Ort"
            [required]="true"
            [clearable]="false"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              @if (item.toLowerCase().includes(searchTerm.toLowerCase())) {
                {{ item }}
              }
            </ng-template>
          </ng-select>
        </fieldset>
        <fieldset class="bm-fieldset flex-1">
          <legend class="bm-fieldset-legend">Lager</legend>
          @if (!showTargetSelection) {
            <div class="bm-input bm-input-disabled">keine Auswahl möglich</div>
          } @else {
            <ng-select
              [items]="warehouses"
              formControlName="warehouse_id"
              placeholder="Lager"
              [required]="true"
              [loading]="loadingWarehouses"
              bindLabel="label"
              bindValue="id"
              [virtualScroll]="true"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.label }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
                @if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                  {{ item.label }}
                }
              </ng-template>
            </ng-select>
          }
        </fieldset>
        <fieldset class="bm-fieldset flex-1">
          <legend class="bm-fieldset-legend">Platz</legend>
          @if (!showTargetSelection) {
            <div class="bm-input bm-input-disabled">keine Auswahl möglich</div>
          } @else {
            <ng-select
              [items]="bins"
              class="w-full"
              formControlName="storage_bin_id"
              placeholder="Platz"
              [required]="true"
              [loading]="loadingbins"
              bindLabel="label"
              bindValue="id"
              [virtualScroll]="true"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.label }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
                @if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                  {{ item.label }}
                }
              </ng-template>
            </ng-select>
          }
        </fieldset>
      </div>
      <section class="flex-1 h-full bm-card bm-card-sm">
        <h4 class="bm-card-title">Artikelliste</h4>
        <ag-grid-angular
          class="ag-theme-quartz h-full"
          [theme]="hawkTheme"
          [loadThemeGoogleFonts]="true"
          [defaultColDef]="defaultColDef"
          [columnDefs]="colDefs"
          [rowClassRules]="rowClassRules"
          [rowSelection]="rowSelection"
          [localeText]="locale"
          [rowData]="articles"
          [alwaysShowVerticalScroll]="true"
        >
        </ag-grid-angular>
      </section>
      <div class="flex flex-row items-center justify-end gap-2">
        <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', deliveryNote.id]">Abbrechen</a>
        @if (deliveryNoteReceipt.controls.location.value === "Lager") {
          <div class="col-auto d-flex flex-column gap-1">
            <small class="text-danger"> </small>
            <button
              [disabled]="deliveryNoteReceipt.invalid || submitting"
              data-tip="Wichtig. Dieser Vorgang ist nicht umkehrbar. Der Knopfdruck bucht die Artikel sofort um"
              class="bm-btn bm-tooltip bm-tooltip-left bm-tooltip-error"
              type="submit"
            >
              Artikel umbuchen
            </button>
          </div>
        }
        @if (deliveryNoteReceipt.controls.location.value === "Verbraucht") {
          <span class="col-auto d-flex flex-column gap-1">
            <button
              [disabled]="deliveryNoteReceipt.invalid || submitting"
              data-tip="Wichtig. Dieser Vorgang ist nicht umkehrbar. Der Knopfdruck setzt alle Artikel sofort auf
              verbraucht!"
              class="bm-btn bm-tooltip bm-tooltip-left bm-tooltip-error"
              type="submit"
            >
              Artikel als verbraucht markieren
            </button>
          </span>
        }
      </div>
    </form>
  }
</div>
